import React from 'react';
import CardGrid from './CardGrid';
import Card from './Card';
import styled from 'styled-components';
import CardGridUnit from './CardGridUnit';

const Wrapper = styled(CardGridUnit)`
  height: 50%;
  max-height: 50%;
`;

const NoPaddingCard = styled(Card)`
  padding: initial;
`;

// force wrap after two items
const addWidth = length => (length === 4 ? 0.00001 : 0);

const toGridItem = (card, i, {length}) => (
  <Wrapper key={i} size={1 / 3 + addWidth(length)}>
    <NoPaddingCard>{card}</NoPaddingCard>
  </Wrapper>
);

const ReportCardGrid = ({children}) => (
  <CardGrid halign={children.length === 5 ? 'left' : 'center'}>{children.map(toGridItem)}</CardGrid>
);

export default ReportCardGrid;
